export const ru = {
  localeCode: 'ru-RU',
  siteName: 'BitTest',
  myOrganization: 'Моя организация',
  youAreAuthorized: 'Вы авторизованы',
  administrator: 'Администратор',
  email: 'Email',
  name: 'Имя',
  users: 'Пользователи',
  role: 'Роль',
  subscription: 'Подписка',
  tokens: 'Токены',
  search: 'Поиск',
  nothingFound: 'Ничего не найдено',
  actions: 'Действия',
  edit: 'Изменить',
  delete: 'Удалить',
  close: 'Закрыть',
  tokensUsage: 'Использование токенов',
  operationsHistory: 'История операций',
  type: 'Тип',
  date: 'Дата',
  sum: 'Сумма',
  withdrawal: 'Списание',
  depositing: 'Пополнение',
  loading: 'Загрузка',
  error: 'Ошибка',
  previous: 'Предыдущая',
  next: 'Следующая',
};
